import { toast } from 'react-toastify';
import SuccessIcon from '../assets/icons/success-check.svg';

export const showSuccessToast = (message) => {
  toast.success(message, {
    icon: ({ theme, type }) => (
      <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-[#6BE2613D]">
        <img src={SuccessIcon} alt="success icon" />
      </div>
    ),
  });
};

export const showErrorToast = (message) => {
  toast.error(message);
};